import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains O&M Subcategory Building Assignment: A classification of building spaces for operations and maintenance cost allocation.',
    name: 'O&M Subcategory Building Assignments',
    partialId: PartialId.Standard.create('func_idc_space'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
